import { useTranslation } from '@thoughtspot/i18n';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { Fragment, useState } from 'react';
import { useGetPrivilegeGroupsQuery } from "../../../../services/role/role-service";
import { renderItemForReviewPrivilege, TranslationsKeys, } from '../util';
import styles from './view-privilege-modal.module.scss';
export const ViewPrivilegeModal = ({ closeModal, name = '', preSelectedPrivilegeIds = [], }) => {
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const { data: privilegesList, error: privilegesListError, loading: privilegesListLoading, refetch: refreshPrivilegesList, } = useGetPrivilegeGroupsQuery();
    const onDismissModal = () => {
        setIsModalOpen(false);
        closeModal();
    };
    const modalProps = {
        size: ModalSize.SMALL,
        title: name,
        onDismiss: onDismissModal,
        isOpen: isModalOpen,
        dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        },
        className: styles.modalProps,
        autoScrollContent: true,
        customPortalClassName: styles.customReactPortal,
    };
    const renderPrivileges = () => privilegesList?.Data?.map((record) => {
        const preSelectedGroupPrivilegeIds = record.privileges.filter(function (privilege) {
            return preSelectedPrivilegeIds.includes(privilege);
        });
        return (React.createElement(Fragment, { key: record.groupName }, preSelectedGroupPrivilegeIds?.length > 0 && (React.createElement(Vertical, null,
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "p-bold", overrideTag: "div" },
                    getTranslations(`tennablePrivilegesLabels.${record.groupName}`),
                    ":")),
            React.createElement(Vertical, { className: styles.reviewPrivilegeMainContainer }, preSelectedGroupPrivilegeIds?.map((item) => renderItemForReviewPrivilege(item, styles.reviewPrivilegeItem, IconID.CIRCLE, styles.reviewIconSize)))))));
    }) || null;
    const privilegeToShow = () => {
        const preSelectedGroupPrivilegeIdsMap = new Set(preSelectedPrivilegeIds);
        return privilegesList?.Data.some((record) => record.privileges.some((privilege) => preSelectedGroupPrivilegeIdsMap.has(privilege)));
    };
    return (React.createElement(React.Fragment, null, privilegesList && (React.createElement(Modal, { ...modalProps }, privilegeToShow() ? (React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
        React.createElement("div", { "data-testid": "rolesModal_view" },
            React.createElement(Vertical, { className: styles.reviewScreen },
                React.createElement(Vertical, { className: styles.reviewPrivilegeGroupContainer }, renderPrivileges()))))) : (React.createElement("div", { className: styles.reviewScreen, "data-testid": "rolesModal_empty" }, t('no.privilegeShow')))))));
};
//# sourceMappingURL=view-privilege-modal.container.js.map